export default "__VITE_ASSET__BneKnu9n__"